import React from 'react';
import type { FieldProps } from '@atlaskit/form';
import JQLBuilder from '@atlassian/jira-jql-builder/src/index.tsx';

type Props = FieldProps<string> & {
	projectKeys: string[];
};

export const Filters = (props: Props) => {
	const { projectKeys, onChange, value } = props;

	return (
		<JQLBuilder
			query={value || ''}
			analyticsSource="jpdRoadmapFilters"
			userPreferencesData={null}
			onSearch={onChange}
			projectKeys={projectKeys}
			excludedFields={['project']}
			basicModeVisibleFields={[]}
			hideTextSearchInput
		/>
	);
};
